<span
  class="lib-badge"
  [class.variant-primary]="variant === 'primary'"
  [class.variant-secondary]="variant === 'secondary'"
  [class.variant-success]="variant === 'success'"
  [class.variant-danger]="variant === 'danger'"
  [class.variant-warning]="variant === 'warning'"
  [class.variant-info]="variant === 'info'"
  [class.size-sm]="size === 'sm'"
  [class.size-md]="size === 'md'"
  [class.size-lg]="size === 'lg'"
  [class.with-dot]="dot"
>
  @if (dot) {
  <span class="badge-dot"></span>
  }
  <ng-content></ng-content>
</span>

